export const MIN_USABLE_WALLET_BALANCE = 1000;

/** Parse API toman balance as-is (no thousand rounding). */
export function parseWalletBalance(
  value: number | string | null | undefined,
): number {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return 0;
  return Math.trunc(parsed);
}

export function isUsableWalletBalance(balance: number): boolean {
  return balance >= MIN_USABLE_WALLET_BALANCE;
}
